// CLARTEXT · Dev-only-Vorschau der Abschlussseite (Sep 2026).
// Route: /dev/abschluss-preview — NUR in Preview-/Dev-Umgebung registriert
// (siehe lib/devPreview.js). Zweck: die neue Abschlussseite (Entscheidungs-
// karten, Modul-Übersicht, finaler CTA) direkt anschauen — besonders mobil —
// ohne vorher eine echte Welt zu erzeugen.
//
// Die eigentliche Seite wird UNVERÄNDERT gerendert: Hero-Chips sind statische
// freigegebene Copy, Preise kommen live aus /api/catalog. KAUFSICHERHEIT:
// buy() bricht ohne sessionStorage-Content ab, BEVOR ein API-Call passiert.
// Damit kein Rest-Content aus einem früheren echten Flow im selben Tab einen
// echten Stripe-Checkout ermöglicht, wird der Key hier beim Öffnen entfernt
// (synchron VOR dem Mount der Seite). Der Trial-CTA navigiert nur zum
// öffentlichen /lp3-Einstieg — dort entsteht ohne Wizard-Durchlauf nichts.
import AbschlussseiteV2 from "@/pages/abschluss/AbschlussseiteV2";
import { ABSCHLUSS_CONTENT_KEY } from "@/components/abschluss/useAbschlussKauffluss";

const BADGE_STYLE = {
  position: "fixed",
  left: 12,
  bottom: 12,
  zIndex: 9999,
  background: "#1a3f6f",
  color: "#fff",
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.04em",
  padding: "6px 12px",
  borderRadius: 999,
  opacity: 0.85,
  pointerEvents: "none",
};

export default function AbschlussPreviewDev() {
  // Synchron vor dem ersten Render der Kindseite (deren Effekte lesen den
  // Key erst nach dem Mount) — verhindert echten Checkout aus Rest-Daten.
  if (typeof window !== "undefined" && window.sessionStorage) {
    try {
      window.sessionStorage.removeItem(ABSCHLUSS_CONTENT_KEY);
    } catch {
      /* sessionStorage gesperrt → buy() bricht ohnehin ohne Content ab */
    }
  }
  return (
    <>
      <AbschlussseiteV2 />
      <div style={BADGE_STYLE} data-testid="abschluss-preview-dev-badge">
        DEV-PREVIEW · Kauf deaktiviert
      </div>
    </>
  );
}
